import React from "react";
import "../styles/screens/UnavailablePage.css";
function UnavailablePage() {
  return (
    <div className="unavailablepage">
      <h1>Comming Soon</h1>
    </div>
  );
}

export default UnavailablePage;
